import { render } from "./CardIcon.vue?vue&type=template&id=2aa8dcf9&scoped=true"
import script from "./CardIcon.vue?vue&type=script&lang=js"
export * from "./CardIcon.vue?vue&type=script&lang=js"

import "./CardIcon.vue?vue&type=style&index=0&id=2aa8dcf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa8dcf9"]])

export default __exports__